import PropTypes from 'prop-types'
import useTranslation from 'next-translate/useTranslation'
import React from 'react'

import { getFormattedAdPrice } from 'SRC/utils'

const renderPriceRange = (priceFrom, priceTo, t) => {
  console.log('priceFrom, priceTo', priceFrom, priceTo)

  if (priceFrom && priceTo) {
    return <div className='price price-range' key='priceRange'>
      <p>{`${getFormattedAdPrice(priceFrom)} ${t('do')} ${getFormattedAdPrice(priceTo)}`} &euro;</p>
    </div>
  } else if (priceFrom && !priceTo) {
    return <div className='price price-range' key='priceFrom'>
      <p>{`${t('Već od')} ${getFormattedAdPrice(priceFrom)}`} &euro;</p>
    </div>
  } else if (!priceFrom && priceTo) {
    return <div className='price price-range' key='priceTo'>
      <p>{`${t('Do')} ${getFormattedAdPrice(priceTo)}`} &euro;</p>
    </div>
  } else {
    return null
  }
}

const renderRetailPrice = (price, oldPrice) => {
  return (
    <>
      <div className='price'>
        <p>{getFormattedAdPrice(price)} &euro;</p>
      </div>

      {oldPrice ? (
        <div className='price-old-price'>
          <span>{getFormattedAdPrice(oldPrice)} &euro;</span>
        </div>
      ) : null}
    </>
  )
}

export const Price = ({ newPrice, oldPrice, priceType, priceFrom, priceTo, priceOnRequest }) => {
  const { t } = useTranslation('common')

  return (
    <div className='price-container'>
      {!priceOnRequest
        ? priceFrom || priceTo
          ? renderPriceRange(priceFrom, priceTo, t)
          : renderRetailPrice(newPrice, oldPrice)
        : <div className='price price-on-request'>
          <p>{t('Cijena na upit')}</p>
        </div>}
      {
        priceType && !priceOnRequest ? <span className='price-type'>
          {priceType === 1 ? t('Fiksno') : priceType === 2 ? t('Po dogovoru') : t('Hitno')}
        </span> : null
      }
    </div>
  )
}

Price.propTypes = {
  newPrice: PropTypes.number.isRequired,
  oldPrice: PropTypes.number,
  priceType: PropTypes.number,
  priceFrom: PropTypes.number,
  priceTo: PropTypes.number,
  priceOnRequest: PropTypes.bool,
  type: PropTypes.string.isRequired,
}
